import { Left, Right } from "@insightfulscience/shared-utils/either";
import { mapGqlError } from "@insightfulscience/shared-utils/gqlClient";
import routes from "../routes";

const expectedErrors = mapGqlError({
	TURING_TEST_FAILED: "errors.TURING_TEST_FAILED",
});

const onSuccess = routingService => () => routingService.push(routes.contact.success);

export const sendContactForm = (request, turingToken, turingType) => ({
	routingService,
	contactService,
}) =>
	contactService
		.requestContact(request, turingToken, turingType)
		.then(onSuccess(routingService))
		.then(Right)
		.catch(Left.from(expectedErrors));
